// ABOUTME: Component to display conditions for truth in a formatted box
// ABOUTME: Used within the verdict section to show when the hypothesis holds true

import React from 'react';

interface ConditionsForTruthProps {
  conditions: string[] | string;
  className?: string;
}

export const ConditionsForTruth: React.FC<ConditionsForTruthProps> = ({
  conditions,
  className = ''
}) => {
  return (
    <div className={`bg-white/50 rounded-lg p-4 ${className}`}>
      <h3 className="font-semibold text-gray-800 mb-3">
        Conditions for Truth
      </h3>
      {Array.isArray(conditions) ? (
        <ul className="space-y-2">
          {conditions.map((condition, idx) => (
            <li key={idx} className="flex items-start gap-2">
              <span className="text-green-500 mt-1">•</span>
              <span className="text-gray-600 text-sm">{condition}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-600 text-sm">{conditions}</p>
      )}
    </div>
  );
};
